import { memo } from 'react';

type Props = {
  name: string;
};

export default memo(function RoutineGroupHeader({ name }: Props) {
  return <h1 className="routine-group__header">{name}</h1>;
});
